export const PRIMARY = "#2D3063";
export const SECONDARY = "#E98C3C";
export const TERTIARY = "#F5DFC6";
export const GREEN = "#97C2A8";
